document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.collapsible_tabs_contet--desktop .collapsible_metafield_tab, .collapsible_tabs_contet--mobile summary');
  const contents = document.querySelectorAll('.collapsible_tabs_contet--desktop .accordion__content');

  contents.forEach(function (content) {
    content.style.display = 'none';
  });
  tabs.forEach(function (tab) {
    tab.classList.remove('tab-active');
  });
  
  tabs.forEach(function (tab, index) {
    tab.addEventListener('click', function () {
      const content = contents[index];
      const ariaExpanded = tab.getAttribute('aria-expanded') === 'true';

      if (ariaExpanded) {
        tab.classList.add('tab-active');
      } else {
        tab.classList.remove('tab-active');
      }

      if (content.style.display === 'block') {
        content.style.display = 'none';
        tab.classList.remove('tab-active');
      } else {
        contents.forEach(function (otherContent) {
          otherContent.style.display = 'none';
        });
        tabs.forEach(function (otherTab) {
          otherTab.classList.remove('tab-active');
        });
        content.style.display = 'block';
        tab.classList.add('tab-active');
      }
    });
  });
});
